import { formBehaviourEnum } from "../../commons/enum/formEnums";

export const isRepeatFormBehaviour = (behaviour) =>
  behaviour === formBehaviourEnum.REPEAT_FORM;

/** Loads persisted document values (GET form) instead of empty model defaults. */
export const loadsExistingDocument = (isView, isRepeatForm = false) =>
  Boolean(isView || isRepeatForm);

/** Persists as a brand-new document (POST without transaction/id fields). */
export const savesAsNewDocument = (isView, isRepeatForm = false) =>
  Boolean(!isView || isRepeatForm);

const REPEAT_FORM_ID_FIELDS = [
  "nroFormulario",
  "NroFormulario",
  "nroTransaccion",
  "NroTransaccion",
  "idTraslado",
  "IdTraslado",
];

export const stripRepeatFormPayload = (form) => {
  if (!form || typeof form !== "object") return form;

  const next = { ...form };
  REPEAT_FORM_ID_FIELDS.forEach((key) => {
    if (key in next) delete next[key];
  });

  if (Array.isArray(next.trasladoTramos)) {
    next.trasladoTramos = next.trasladoTramos.map((tramo) => ({
      ...tramo,
      idTramo: 0,
      nroTramoUnico: null,
      idEstado: null,
      recorridoEditable: true,
      gestionEditable: true,
    }));
  }

  return next;
};

/**
 * Un traslado duplicado arranca sin identidad ni estado de los tramos
 * originales, con recorrido y gestión 100% editables y con las fechas
 * del recorrido vacías para que se recarguen.
 */
export const prepareRepeatTrasladoValues = (values) => {
  if (!values) return values;

  const next = { ...values };
  REPEAT_FORM_ID_FIELDS.forEach((key) => {
    if (key in next) delete next[key];
  });

  const resetTramo = (tramo) => ({
    ...tramo,
    idTramo: 0,
    nroTramoUnico: null,
    idEstado: null,
    fechaHoraTraslado: null,
    recorridoEditable: true,
    gestionEditable: true,
  });

  return {
    ...next,
    fechaHoraSolicitud: new Date(),
    fechaHoraTurno: null,
    trasladoTramos: next.trasladoTramos?.length
      ? next.trasladoTramos.map(resetTramo)
      : next.trasladoTramos,
    tramos: next.tramos?.length
      ? next.tramos.map(resetTramo)
      : next.tramos,
    puntos: next.puntos?.length
      ? next.puntos.map((punto) => ({
        ...punto,
        idTramo: 0,
        nroTramoUnico: null,
        idEstado: null,
        fechaHora: null,
        recorridoEditable: true,
        gestionEditable: true,
      }))
      : next.puntos,
  };
};
